


// import React, { useEffect, useState, useMemo, useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Card, Col } from 'react-bootstrap';
// import { FaStar, FaRegStar } from 'react-icons/fa';
// import { BsRepeat, BsEye, BsHeart, BsHeartFill, BsCartPlusFill } from 'react-icons/bs';
// import { AiOutlineShoppingCart } from 'react-icons/ai';
// import { handleAddToCart, toggleWishlist } from '../utils/productAction';
// import { calculateDiscountAndFinalPrice } from '../utils/priceCalculation';
// import { useNavigate } from 'react-router-dom';
// import '../css/productCard.css';
// import { addToCompare } from '../redux/compareSlice';
// import StartRating from './starRating';
// import { calculateAverageRating } from '../utils/calculateRatingReview';
// // import { selectAverageRating, selectNumberOfReviews, selectCombinedReviewsByProductId } from '../redux/reviewSlice';
// import { selectCombinedReviews, selectAverageRating, selectNumberOfReviews } from '../utils/reviewSelector';

// const ProductCard = React.memo(({ product }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [isAdded, setIsAdded] = useState(false);
//    const [isAddedW, setIsAddedW] = useState(false);
//   // Memoize selectors to avoid recalculations
//   const wishlistItems = useSelector(state => state.wishlist.wishlistItems);
//   const cartItems = useSelector(state => state.cart.cartItems);
//   const compareItems = useSelector((state) => state.compare.compareItems);
//   // Memoize product-related checks
//   const isWishlisted = useMemo(() => wishlistItems.some(item => item.id === product.id), [wishlistItems, product.id]);
//   const isCardlisted = useMemo(() => cartItems.some(item => item.id === product.id), [cartItems, product.id]);
//   const isComparelisted = useMemo(() => compareItems.some(item => item.id === product.id), [compareItems, product.id]);
//   // Use utility function to calculate the discount and final price
//   const { finalPrice } = useMemo(() => calculateDiscountAndFinalPrice(product.price, product.discount), [product.price, product.discount]);
//   const isOutOfStock = useMemo(() => product.stock === 0, [product.stock]);


//   // const reviews = useSelector((state) => selectCombinedReviewsByProductId(state, productId));
//   const combinedReviewsList = useSelector(selectCombinedReviews(product?.id));
//   const averageRating = selectAverageRating(combinedReviewsList);
//   const numberOfReviews = selectNumberOfReviews(combinedReviewsList);
//   // Optimize functions using useCallback to prevent unnecessary re-renders
//   const handleViewProduct = useCallback(() => {
//     if (product && product.id) {
//       window.scrollTo(0, 0);
//       navigate(`/product/${product.id}`);
//     } else {
//       console.error("Product or product ID is undefined");
//     }
//   }, [navigate, product]);


//   const handleCompareProduct = useCallback(()  => {
//     dispatch(addToCompare({ ...product, finalPrice }));
//     // Navigate to compare page after adding product

//   }, [dispatch, product, finalPrice]);

  
//   // Check if product data is available
//   if (!product || !product.image || !product.price) {
//     console.error('Product data is undefined or missing essential fields');
//     return null;
//   }


//   return (
//     <Col md={12} className="mb-1 ps-2 pe-2 mb-sm-3 mainProductCart">
//       <Card className={`productCard ${isOutOfStock ? 'out-of-stock' : ''}`}>
//         <div className="productsThumb">
//           <div className="productsThumbLink">
//             {isOutOfStock && (
//               <div className="outOfStockLabel">
//                 <span className="outOfStock">Stock Out</span>
//               </div>
//             )}
//             {product.discount && !isOutOfStock && (
//               <div className="productLabel">
//                 <span className="onsale">-{product.discount}%</span>
//               </div>
//             )}
//             <div className="productImg">
//               <img src={product.image} alt={product.name} />
//             </div>
//             {!isOutOfStock && (
//               <div className="productMenuList">
//                 <ul>
//                   <li
//                     onClick={() => handleAddToCart(dispatch, product, cartItems,setIsAdded)}
//                     className={isCardlisted ? 'stayColor added' : 'stayColor'}
                    
//                   >
//                     {isCardlisted ? <BsCartPlusFill /> : <AiOutlineShoppingCart />}
//                   </li>
//                   <li  onClick={handleCompareProduct}
//                    className={isComparelisted ? 'stayColor added' : 'stayColor'}
//                   >
//                   <BsRepeat />
//                 </li>
//                   <li
//                     onClick={() => toggleWishlist(dispatch, product, wishlistItems, isWishlisted,setIsAddedW)}
//                     className={isWishlisted ? 'stayColor added' : 'stayColor'}
                   
//                   >
//                     {isWishlisted ? <BsHeartFill /> : <BsHeart />}
//                   </li>
//                   <li onClick={handleViewProduct} aria-label="View product"><BsEye /></li>
//                 </ul>
//               </div>
//             )}
//           </div>
//         </div>
//         <div className="productCaption">
//           <div className="ProductReview">
//             <div className="ratings mt-1 d-flex align-items-center gap-2">
//               <div className="rating-stars">
//                 <ul id="stars">
//                    <StartRating productRating={averageRating}/>
                  
//                 </ul>
//               </div>
//               <p className="p-0 m-0 mt-1 starratingtext">({numberOfReviews})</p>
//             </div>
//           </div>
//           <div className="productName">
//             <div
//               onClick={!isOutOfStock ? handleViewProduct : () => console.log('Out of stock')}
//             >
//               <h3>{product.name}</h3>
//             </div>
//           </div>
//           <div className="productPrize d-block mt-2 mt-sm-0 d-sm-flex align-items-center justify-content-between w-100">
//             {product.discount ? (
//               <>
//                 <h4 className="discountedPrice">${finalPrice.toFixed(2)}</h4>
//                 <h4 className="originalPrice">
//                   <del style={{ fontSize: '13px', opacity: '0.6' }}>${product.price.toFixed(2)}</del>
//                 </h4>
//               </>
//             ) : (
//               <h4>${product.price.toFixed(2)}</h4>
//             )}
//           </div>
//         </div>
//       </Card>
//     </Col>
//   );
// });

// export default ProductCard;




import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Card, Col } from 'react-bootstrap';
import { BsRepeat, BsEye, BsHeart, BsHeartFill, BsCartPlusFill } from 'react-icons/bs';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import '../css/productCard.css';
import StartRating from './starRating';


import useProductActions from '../utils/productThanos';
const ProductCard = React.memo(({ product,axlio,viewMode,axliox }) => {
    const {
      finalPrice,
      isWishlisted,
      cartItem,
      isComparelisted,
      averageRating,
      numberOfReviews,
      handleViewProduct,
      handleCompareProduct,
      handleAddToWishlist,
      handleAddToCards
    } = useProductActions(product);
    const isOutOfStock = useMemo(() => product.stock === 0, [product.stock]);
    // Check if product data is available
    if (!product || !product.image || !product.price) {
      console.error('Product data is undefined or missing essential fields');
      return null;
    }


  return (
    <Col md={12} lg={axliox}  className={`mb-1 ps-2 pe-2 mb-sm-3 mainProductCart ${viewMode === 'list' ? 'product-list-view' : 'product-grid-view'}`}>
       <Card className={`productCard ${isOutOfStock ? 'out-of-stock' : ''}`}>
        <div className="productsThumb">
          <div className="productsThumbLink">
            {isOutOfStock && (
              <div className="outOfStockLabel">
                <span className="outOfStock">Stock Out</span>
              </div>
            )}
            {product.discount && !isOutOfStock && (
              <div className="productLabel">
                <span className="onsale">-{product.discount}%</span>
              </div>
            )}
            <div className="productImg">
              <img src={product.image} alt={product.name} />
            </div>
            {!isOutOfStock && (
              <div className="productMenuList">
                <ul>
                  <li
                    onClick={handleAddToCards}
                    className={cartItem ? 'stayColor added' : 'stayColor'}
                    
                  >
                    {cartItem ? <BsCartPlusFill /> : <AiOutlineShoppingCart />}
                  </li>
                  <li  onClick={handleCompareProduct}
                   className={isComparelisted ? 'stayColor added' : 'stayColor'}
                  >
                  <BsRepeat />
                </li>
                  <li
                    onClick={handleAddToWishlist}
                    className={isWishlisted ? 'stayColor added' : 'stayColor'}
                   
                  >
                    {isWishlisted ? <BsHeartFill /> : <BsHeart />}
                  </li>
                  <li onClick={handleViewProduct} aria-label="View product"><BsEye /></li>
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className="productCaption">
          <div className="ProductReview">
            <div className="ratings mt-1 d-flex align-items-center gap-2">
              <div className="rating-stars">
                <ul id="stars">
                   <StartRating productRating={averageRating}/>
                  
                </ul>
              </div>
              <p className="p-0 m-0 mt-1 starratingtext">({numberOfReviews})</p>
            </div>
          </div>
          <div className="productName">
            <div
              onClick={!isOutOfStock ? handleViewProduct : () => console.log('Out of stock')}
            >
              <h3>{product.name}</h3>
            </div>
          </div>
          <div className="productPrize d-block mt-2 mt-sm-0 d-sm-flex align-items-center justify-content-between w-100">
            {product.discount ? (
              <>
                <h4 className="discountedPrice">${finalPrice.toFixed(2)}</h4>
                <h4 className="originalPrice">
                  <del style={{ fontSize: '13px', opacity: '0.6' }}>${product.price.toFixed(2)}</del>
                </h4>
              </>
            ) : (
              <h4>${product.price.toFixed(2)}</h4>
            )}
          </div>
        </div>
      </Card>
    </Col>
  );
});

export default ProductCard;

